import BranchesPage from "../admin/BranchesPage";
import UserListPage from "../admin/UserListPage";
import Dashboard from "../admin/Dashboard";
import ProductList from "../admin/ProductList";
import InventoryPage from "../admin/InventoryPage";
import AdminCalendarPage from "../admin/CalendarPage";
import UnderConstructionPage from "../components/CommonComponents/UnderConstructionIcon";
import Analytics from "../admin/Analytics";
import ProtectedRoute from "./ProtectedRoute";
import MainLayout from "../components/CommonComponents/MainLayout";
import TransactionList from "../components/transaction/TransactionList";
import Reports from "../admin/Reports";
import ExpensesPage from "../components/pos/pages/ExpensesPage";

import PreReleaseTracker from "../admin/PreReleaseTracker";

export const adminRoutes = [
    {
        path: "/admin/branches",
        element: <ProtectedRoute allowedRoles={[1]} disallowManager><MainLayout><BranchesPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/user-list",
        element: <ProtectedRoute allowedRoles={[1]} disallowManager><MainLayout><UserListPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/dashboard",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Dashboard /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/transactions",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><TransactionList restrictToToday={false} showSummary={true} useExpensesPagination={true} /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/expenses",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><ExpensesPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/products",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><ProductList /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/inventory",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><InventoryPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/calendar",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><AdminCalendarPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/analytics",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Analytics /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/pre-release-tracker",
        element: <ProtectedRoute allowedRoles={[1]} disallowManager><MainLayout><PreReleaseTracker /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/reports",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Reports /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/settings",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><UnderConstructionPage /></MainLayout></ProtectedRoute>,
    },
];
